import React from 'react'
import { CButton, CModal, CModalBody, CModalFooter } from '@coreui/react'

const LiveStreamStartStopModal = ({ type, loading, onStop, onStart, onCancel }) => {
  return (
    <CModal size="lg" scrollable visible={true} alignment="center" className=" border-0">
      <div
        className="px-5 text-white w-100 d-flex align-items-center"
        style={{ height: '3.8vw', backgroundImage: 'linear-gradient(to bottom, #646464, #111)' }}
      >
        <p style={{ fontSize: '1.5625vw' }} className="mb-0">
          {type === 'START' ? 'Start Live Stream ?' : 'Stop Live Server ?'}
        </p>
      </div>
      <CModalBody className="px-5 py-4">
        <p style={{ fontSize: '14px' }}>
          {type === 'START'
            ? `Before you start the Live Stream, make sure you're ready to broadcast your video before you click Start.`
            : 'Are you sure you want to stop the Live Server ?'}
        </p>
      </CModalBody>
      <CModalFooter className={`px-5 border-0 `}>
        <CButton
          style={{ color: 'black', border: '1px solid black', fontSize: '.9vw' }}
          className="mx-4 bg-white rounded-1 btn-focus-none px-4"
          type="submit"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </CButton>
        <CButton
          style={{ fontSize: '.9vw' }}
          className="text-white rounded-1 btn-focus-none px-4"
          type="submit"
          color={type === 'START' ? 'success' : 'danger'}
          onClick={type === 'START' ? () => onStart() : () => onStop()}
          disabled={loading}
        >
          {type === 'START' ? 'Start' : 'Stop'}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default LiveStreamStartStopModal
